// extracted by mini-css-extract-plugin
export default {"primaryColor":"#354760","white":"#fff","container":"styles_container__K3+Zu","information":"styles_information__IARzc","chevron":"styles_chevron__6nifT"};